import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=076190f4&scoped=true&"
import script from "./actions.vue?vue&type=script&lang=js&"
export * from "./actions.vue?vue&type=script&lang=js&"
import style0 from "./actions.vue?vue&type=style&index=0&id=076190f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076190f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076190f4')) {
      api.createRecord('076190f4', component.options)
    } else {
      api.reload('076190f4', component.options)
    }
    module.hot.accept("./actions.vue?vue&type=template&id=076190f4&scoped=true&", function () {
      api.rerender('076190f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reference-clients/data-table/actions.vue"
export default component.exports